<img alt="Icon" class="h-[2rem]" src="/assets/icons/compliance/file-thumbnails.svg">
<div class="flex flex-col gap-1 w-full">
  <span class="cd-text-b3 w-full truncate">{{ fileName }}</span>
  <div class="flex items-center">
    <span class="cd-text-b4 font-medium text-neutral-600 mr-auto">{{ fileSize }}</span>
    @if (badge) {
      <span class="cd-text-b5 text-primary-700 bg-primary-100 px-2 py-1 rounded-full w-fit file-widget-badge">{{ badge }}</span>
    }
  </div>
</div>
@if (showActions) {
  <div class="flex flex-row gap-2 ml-auto">
    @if (showDownload) {
      <button (click)="download.emit()" class="btn btn-neutral-text !px-1 !py-1 my-auto w-8" type="button">
        <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/download.svg">
      </button>
    }
    @if (showRemove) {
      <button (click)="remove.emit()" class="btn btn-neutral-text !px-1 !py-1 my-auto w-8" type="button">
        <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/x.svg">
      </button>
    }
  </div>
}
